import trackEvent from '@/track/trackEvent'
import { getCurrentPageName } from '@/utils/common'

// 进入内容详情页
const enterContentDetail = (
  postId: string,
  authorId: string,
  enterFrom: string,
  extra: Record<string, any> = {}
) => {
  trackEvent.track('enter_post_detail', {
    post_id: postId,
    author_id: authorId,
    enter_from: enterFrom,
    ...extra
  })
}

// 进入订单列表页
const enterOrderList = () => {
  trackEvent.track('click_order_entrance')
}

// 系列曝光
const seriesExposure = (seriesId: string, authorId: string) => {
  trackEvent.track('post_show', {
    item_type: 'series',
    series_id: seriesId,
    author_id: authorId,
    page_name: 'homepage_hot',
    tab_name: 'hot'
  })
}

// 系列点击
const seriesClick = (seriesId: string, authorId: string) => {
  trackEvent.track('post_click', {
    item_type: 'series',
    series_id: seriesId,
    author_id: authorId,
    page_name: 'homepage_hot',
    tab_name: 'hot'
  })
}

// 贴子系列入口曝光
const seriesEntryExposure = (
  seriesId: string,
  postId: string,
  authorId: string,
  isSelf: boolean = true,
  extra: Record<string, any> = {}
) => {
  trackEvent.track('series_entrance_show', {
    series_id: seriesId,
    post_id: postId,
    author_id: authorId,
    page_name: getCurrentPageName(isSelf),
    ...extra
  })
}

// 贴子系列入口点击
const seriesEntryClick = (
  seriesId: string,
  postId: string,
  authorId: string,
  isSelf: string | boolean = true,
  enterFrom: string = 'homepage_hot',
  extra: Record<string, any> = {}
) => {
  trackEvent.track('series_entrance_click', {
    series_id: seriesId,
    post_id: postId,
    author_id: authorId,
    page_name: enterFrom,
    ...extra
  })
}

// like
const itemLike = (
  itemType: 'video' | 'image' | 'series',
  postId: string,
  authorId: string,
  pageName: string,
  enterFrom?: string,
  extra: Record<string, any> = {}
) => {
  trackEvent.track('like', {
    item_type: itemType,
    post_id: postId,
    author_id: authorId,
    page_name: pageName,
    ...(enterFrom ? { enter_from: enterFrom } : {}),
    ...extra
  })
}

// 点击同款按钮-使用同款模型
const clickSameStyleBtn = (
  eventName: string,
  postId: string,
  authorId: string,
  pageName: string = 'post_detail',
  extra: Record<string, any> = {}
) => {
  trackEvent.track(eventName, {
    post_id: postId,
    author_id: authorId,
    page_name: pageName,
    ...extra
  })
}

// 挑战生成页展现
const challengeDesignShow = (enterFrom: string) => {
  trackEvent.track('enter_challenge_generator_page', {
    enterFrom
  })
}

// IP风险提示，展示
const ipRemindPopShow = () => {
  trackEvent.track('ip_remind_popup_show', {
    source: 'generate_tool'
  })
}

// IP风险提示，点击去修改
const ipRemindPopModify = () => {
  trackEvent.track('ip_popup_modify', {
    source: 'generate_tool'
  })
}

// IP风险提示，点击继续发布
const ipRemindPopContinue = () => {
  trackEvent.track('ip_popup_continue_post', {
    source: 'generate_tool'
  })
}

// 模型风格选择
const modelStyleSelect = (pageName: string, name: string) => {
  trackEvent.track('click_model_style', {
    page_name: pageName,
    model_style_name: name
  })
}

export default {
  enterContentDetail,
  enterOrderList,
  seriesExposure,
  seriesClick,
  seriesEntryExposure,
  seriesEntryClick,
  itemLike,
  clickSameStyleBtn,
  challengeDesignShow,
  ipRemindPopShow,
  ipRemindPopModify,
  ipRemindPopContinue,
  modelStyleSelect
}
